  <template>
  <div class="general-wrapper">
    <Header v-if="tableType == 'marketplace'" :parent="`${tableType}`">
      <template #title>
        {{ $t("tables.orders_history") }}
      </template>
      <template #actions>
        <!-- <DashboardButton @click="doExport">
          {{ $t("tables.export") }}
        </DashboardButton> -->
      </template>
    </Header>

     <Header v-if="tableType == 'systems'" :parent="`/${tableType}`">
      <template #title>
        {{ $t("tables.payments_history") }}
      </template>
      <template #actions>
        <!-- <DashboardButton @click="doExport">
          {{ $t("tables.export") }}
        </DashboardButton> -->
      </template>
    </Header>

     <Header v-if="tableType == 'delivery'">
      <template #title>Історія доставок</template>
     </Header>

     <Header v-if="tableType == 'casino'" :parent="`tools`">
      <template #title>Історія розіграшів</template>
     </Header>
     

    <div class="table-container">
      <MarketplaceTransactionsTable
        ref="marketplaceTable"
        v-if="tableType == 'marketplace'"
      />
      <SubscriptionsTransactionsTable
        ref="systemsTable"
        v-if="tableType == 'systems'"
      />
      <DeliveryOrdersTable v-if="tableType == 'delivery'" />
      <RouletteRollsTable v-if="tableType == 'casino'"/>
    </div>
  </div>
</template>

<script>
import MarketplaceTransactionsTable from "@/components/billing/TransactionsTable.vue";
import SubscriptionsTransactionsTable from "@/components/subscriptions/TransactionsTable.vue";
import DeliveryOrdersTable from "@/components/delivery/DeliveryOrdersTable.vue";
import RouletteRollsTable from "@/components/marketing/RouletteRollsTable.vue"

import DashboardButton from "@/components/DashboardButton.vue";

export default {
  components: {
    MarketplaceTransactionsTable,
    SubscriptionsTransactionsTable,
    DashboardButton,
    DeliveryOrdersTable,
    RouletteRollsTable
  },
  methods: {
    doExport() {
      if (this.tableType == "marketplace") {
        this.$refs.marketplaceTable.exportToCsv();
      } else if (this.tableType == "systems") {
        this.$refs.systemsTable.exportToCsv();
      }
    },
  },
  computed: {
    tableType() {
      return this.$route.params.type;
    },
  },
};
</script>

<style scoped>
.table-container {
}
</style>